/**
 * "HAS THIS SESSION FINISHED WITH ONBOARDING?" — one boolean, and NO IMPORTS.
 *
 * It lives in its own file for exactly one reason: `main.ts` is SHELL code,
 * inside a 150 KB gz budget a visitor pays before first paint, and
 * `onboarding-gate.ts` reaches the coach and the match chunk. A router that
 * asked the gate module whether to mount the gate would drag all of that into
 * the shell to answer a question whose answer is a boolean.
 *
 * ── WHY IN MEMORY, PER PAGE LOAD ────────────────────────────────────────────
 * NOT `localStorage`. A "seen the tutorial" flag on the device is a flag a
 * re-install clears and a second device never had — which is the friction §6
 * exists to remove — and it would also let a player un-skip a skip by clearing
 * site data. The truth is `onboarding_progress`, server-side; this is a cache
 * of one answer for the life of one page load, so the meta shell being rebuilt
 * on every tab tap does not become one `GET /onboarding` per tap.
 *
 * A false negative costs one request and a frame of "Getting your progress…".
 * A false positive cannot happen: only the server saying "complete" sets it.
 */
let settled = false;

/** True once the server has said this session has no onboarding left to do. */
export function onboardingSettled(): boolean {
  return settled;
}

/** Called by the gate when the server has answered. Never by a screen. */
export function markOnboardingSettled(): void {
  settled = true;
}

/**
 * Forget it — the next session may be a different human.
 *
 * Called from `signOut()` in `main.ts`, and by the tests.
 */
export function resetOnboardingGate(): void {
  settled = false;
}
